import LinkOffIcon from '@mui/icons-material/LinkOff';
import InfoIcon from '@mui/icons-material/Info';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import {
    Tooltip,
    Avatar,
    Button,
    Typography,
    CircularProgress,
    Box,
    IconButton,
} from '@mui/material';

export const matchedTableHeaders = (
    loadingRowId,
    handleUnmatchAggFileInventoryAndPlaidTransaction,
    showUnmatchButton = true,
    onInfoClick = null,
) => {
    return [
        {
            id: 'date',
            label: 'Date',
            sort: false,
        },
        {
            id: 'account_name',
            label: 'Account Name',
            sort: false,
        },
        {
            id: 'description',
            label: (
                <Box display="flex" alignItems="center" gap={0.5}>
                    Description
                    {showUnmatchButton && (
                        <Tooltip
                            title="The blue wallet icon indicates a refund transaction. Click the icon to view refund details."
                            arrow
                            placement="top"
                        >
                            <InfoIcon
                                fontSize="small"
                                color="action"
                                sx={{ opacity: 0.7, fontSize: '16px' }}
                            />
                        </Tooltip>
                    )}
                </Box>
            ),
            sort: false,
            render: (row) => {
                const refundTransaction = row.aggregated_file_inventories[0]?.refund_transaction;

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <span>
                            {`${row.description}${row.card_data?.card_number
                                ? ` (x${row.card_data?.card_number})`
                                : ''
                                }`}
                        </span>
                        {refundTransaction && (
                            <Tooltip title="View refund details" arrow>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (onInfoClick) {
                                            onInfoClick({
                                                date: refundTransaction.date,
                                                amount: refundTransaction.amount,
                                                description: refundTransaction.description,
                                                transactionId: refundTransaction.id,
                                            });
                                        }
                                    }}
                                >
                                    <AccountBalanceWalletIcon fontSize="small" color="primary" />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                );
            },
        },
        {
            id: 'inventoryDescription',
            label: 'Inventory Description',
            sort: false,
            render: (row) => (
                <Box>
                    {row?.aggregated_file_inventories?.length ? (
                        row.aggregated_file_inventories.map((inventory, index) => (
                            <>
                                <Typography key={index} fontSize="12px">

                                    {`${inventory.reference_id ? `${inventory.reference_id} (${inventory.purchase_id ? `${inventory.purchase_id}),` : ''
                                        } Section: ${inventory.class_1}, Row: ${inventory.class_2
                                        }, Seats: ${inventory.seats}` : ''}`}
                                </Typography>
                                <Typography key={`${index}-desc`} fontSize="12px">
                                    {`${inventory.expires_at}, ${inventory?.description}${inventory?.venue ? `, ${inventory?.venue}` : ''
                                        }`}
                                </Typography>
                            </>
                        ))
                    ) : (
                        <Typography fontSize="12px">-</Typography>
                    )}
                </Box>
            ),
        },
        // {
        //     id: 'reference_id',
        //     label: 'Reference ID',
        //     sort: false,
        //     render: (row) => {
        //         const referenceIds = row?.aggregated_file_inventories
        //             ?.map((inv) => inv.reference_id)
        //             .filter(Boolean);
        //         return referenceIds?.length ? referenceIds.join(', ') : '-';
        //     },
        // },
        // {
        //     id: 'purchase_id',
        //     label: 'Purchase ID',
        //     sort: false,
        //     render: (row) => {
        //         const purchaseIds = row?.aggregated_file_inventories
        //             ?.map((inv) => inv.purchase_id)
        //             .filter(Boolean);
        //         return purchaseIds?.length ? purchaseIds.join(', ') : '-';
        //     },
        // },
        {
            id: 'matchedPaymentPlan',
            label: 'Payment Plan',
            sort: false,
            render: (row) => `${row?.matched_payment_plan?.name || '-'}`,
        },
        {
            id: 'amount',
            label: 'Total',
            sort: false,
            render: (row) => `${row.currency_code} ${row.amount}`,
        },
        {
            id: 'matched_by',
            label: 'Matched By',
            sort: false,
            render: (row) =>
                row?.first_name ? (
                    <Tooltip
                        title={
                            <Typography
                                textAlign="center"
                                fontSize="12px"
                                sx={{ textAlign: 'center' }}
                            >
                                {row.first_name} {row.last_name}
                            </Typography>
                        }
                    >
                        <Avatar sx={{ width: 30, height: 30 }}>
                            <Typography fontSize="12px">
                                {row.first_name?.[0].toUpperCase()}
                                {row.last_name?.[0].toUpperCase()}
                            </Typography>
                        </Avatar>
                    </Tooltip>
                ) : (
                    <Typography fontSize="12px">-</Typography>
                ),
        },
        ...(showUnmatchButton
            ? [
                {
                    id: 'action',
                    label: '',
                    sort: false,
                    render: (row) =>
                        loadingRowId === row?.id ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            <Button
                                sx={{ padding: 0, color: 'gray' }}
                                onClick={() =>
                                    handleUnmatchAggFileInventoryAndPlaidTransaction([row?.id])
                                }
                            >
                                {<LinkOffIcon fontSize="small" />}
                                <Typography fontSize="12px"> Unmatch</Typography>
                            </Button>
                        ),
                },
            ]
            : []),
    ];
};
